<template>
  <div class="statusPage">
    <div class="pageTop">
      <h1>设备离线状态(数据每整点统计一次)</h1>
      <el-button @click="getall()">刷新</el-button>
    </div>
    <div class="totalNum">
      <div class="totalNum__left">
        <div>
          <p>
            设备总数量
            <el-tooltip
              effect="light"
              placement="top"
              class="custom-tooltip"
              popper-class="custom-tooltip-popper"
            >
              <div slot="content">
                <h2 class="tooltip-title">已过滤(相关打标签设备)</h2>
                <div class="button-group">
                  <el-button type="text" class="tooltip-button">撤机</el-button>
                  <el-button type="text" class="tooltip-button">测试</el-button>
                  <el-button type="text" class="tooltip-button">展示</el-button>
                  <el-button type="text" class="tooltip-button">展会</el-button>
                  <el-button type="text" class="tooltip-button">已切</el-button>
                  <el-button type="text" class="tooltip-button">已废</el-button>
                  <el-button type="text" class="tooltip-button">待撤</el-button>
                  <el-button type="text" class="tooltip-button"
                    >未使用</el-button
                  >
                  <el-button type="text" class="tooltip-button">被盗</el-button>
                  <el-button type="text" class="tooltip-button"
                    >景区异常</el-button
                  >
                  <el-button type="text" class="tooltip-button"
                    >待报废</el-button
                  >
                  <el-button type="text" class="tooltip-button"
                    >已移机</el-button
                  >
                </div>
              </div>
              <i class="tooltip-trigger">?</i>
            </el-tooltip>
          </p>
          <p class="count">{{ totalOnline + totalOffline }}</p>
        </div>
        <div>
          <p>离线时间>=24小时设备数量</p>
          <p class="count">{{ totalOffline }}</p>
        </div>
      </div>
      <div class="totalNum__right">
        <h3>
          设备离线列表
          <el-tooltip effect="light" placement="top" class="custom-tooltip">
            <div slot="content">
              <br />
              <el-button type="text">统计离线时长大于等于24小时的设备</el-button>
              <br />
            </div>
            <i>?</i>
          </el-tooltip>
        </h3>
      </div>
    </div>
    <!-- <DeviceStatusChart :totalOnline="totalOnline+totalOffline" :totalOffline="totalOffline" /> -->
    <div class="pageTop">
      <h2>景区选择</h2>
      <SearchSelect
        className="longSelect"
        v-model="store"
        :options="storeOptions"
        :props="{
          label: 'label',
          value: 'value',
        }"
        placeholder="请选择景区"
      />
      <h2>离线时间</h2>
      <SearchSelect
        :select="select"
        :clear="clear"
        className="longSelect"
        v-model="time_frame"
        :options="times"
        :props="{
          label: 'label',
          value: 'value',
        }"
        placeholder="请选择时间"
      />

      <el-button @click="handleQuery">查询</el-button>
      <el-button size="small" @click="handleDownload" icon="el-icon-download"
        >下载</el-button
      >
    </div>
    <div class="deviceBox">
      <div class="leftBox">
        <div class="title">
          <!-- <h2>设备离线状态监控</h2> -->
        </div>
        <template v-if="offlineList && offlineList.length > 0">
          <ul>
            <li v-for="item in displayedData.slice(0, 10)" :key="item.id">
              <p>{{ item.name }}</p>
              <p>已离线{{ item.time }}天</p>
            </li>
          </ul>
        </template>
        <div v-else class="noData">暂无数据...</div>
      </div>
      <div class="rightBox">
        <template v-if="offlineList && offlineList.length > 0">
          <ul>
            <li v-for="item in displayedData.slice(10, 20)" :key="item.id">
              <p>{{ item.name }}</p>
              <p>已离线{{ item.time }}天</p>
            </li>
          </ul>
        </template>

        <div v-else class="noData">暂无数据...</div>
      </div>
    </div>
    <div>
      <el-pagination
        background
        :layout="layout"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        :total="offlineList.length"
      />
    </div>
  </div>
</template>

<script>
import SearchSelect from "@/views/components/SearchSelect";
import DeviceStatusChart from "./DeviceStatusChart.vue";
import {
  getDeviceDownload,
  getDeviceNum,
  getDeviceOffline,
  getDeviceOfflineDownload,
  getSaleOffline,
} from "@/api/bi";

export default {
  name: "DeviceStatus",
  data() {
    return {
      store: "",
      time_frame: "1",
      gte: 0,
      lte: 0,
      select: false,
      clear: false,
      category: ["1", "2", "3", "4","5","6","7","8"],
      options: [
        { value: "1", label: "771/772" },
        { value: "2", label: "775" },
        { value: "3", label: "776" },
        { value: "4", label: "779" },
        { value: "5", label: "780" },
        { value: "6", label: "781" },
        { value: "7", label: "782" },
        { value: "8", label: "783" }
      ],
      times: [
        {
          label: "离线时间大于等于24小时",
          value: "1",
        },
        {
          label: "离线时间大于6小时小于12小时",
          value: "2",
        },
      ],
      offlineList: [], // 离线设备
      salesStatusList: [], // 设备销售状态
      currentPage: 1, // 当前页码
      currentPageRight: 1, // 当前页码
      pageSize: 20, // 每页显示条数
      layout: "total,  prev, pager, next, jumper", // 分页数据
      totalOnline: 0, // 在线设备数量
      totalOffline: 0,
    };
  },
  props: ["allStore"], // 全部景区列表
  beforeMount() {
    this.getNum();
    this.getData();
    // this.getSalesList();
  },
  methods: {
    getall() {
      this.getData();
      this.getNum();
    },
    // 清除el-select搜索文本框的值query
    onSelectChange() {
      this.$refs["el-select3"].query = "";
    },
    handleQuery() {
      // 查询
      // 页码重置为1
      this.currentPage = 1; // 当前页码
      this.currentPageRight = 1;
      this.getData();
      this.getNum();
      // this.getSalesList();
    },
    checktime() {
      if (this.time_frame === "1") {
        this.gte = 24;
        this.lte = 0;
      } else if (this.time_frame === "2") {
        this.lte = 12;
        this.gte = 6;
      }
    },
    getData(val) {
      if (val === "manual") {
        this.currentPage = 1;
      }
      this.checktime();
      // 请求参数
      const params = {
        source: [...this.category], // 业务分类
        company_id_list: [...this.store], // 景区列表
        lte: this.lte,
        gte: this.gte,
        // company_id_list: ['cad7d66f2e6bec50'] // 景区列表
      };
      getDeviceOffline(params).then((res) => {
        this.offlineList = [];
        if (res && res.code === 2000 && res.data) {
          if (res.data.constructor.name === "Array") {
            res.data.map((val) => {
              this.offlineList.push({
                name: val.device_name,
                time: val.time,
                id: val.device_id,
              });
            });
          }
        }
      });
    },
    getNum() {
      getDeviceNum().then((res) => {
        if (res && res.code === 2000 && res.data) {
          this.totalOnline = 0;
          this.totalOffline = 0;
          for (const key in res.data) {
            if (res.data.hasOwnProperty(key)) {
              this.totalOnline += res.data[key].online || 0;
              this.totalOffline += res.data[key].no_online || 0;
            }
          }
        }
      });
    },
    getSalesList() {
      const params = {
        source: [...this.category], // 业务分类
        company_id_list: [...this.store], // 景区列表
      };
      getSaleOffline(params).then((res) => {
        this.salesStatusList = [];
        if (res && res.code === 2000 && res.data) {
          if (res.data.constructor.name === "Array") {
            res.data.map((val) => {
              this.salesStatusList.push({
                name: val.device_name,
                time: val.time,
                id: val.device_id,
              });
            });
          }
        }
      });
    },
    handleSelect(val) {
      // 接收来自组件的数据
      this.store = val;
    },
    // 处理每页条数变化
    handleSizeChange(val) {
      this.pageSize = val;
    },
    // 处理当前页码变化
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    // 处理当前页码变化
    handleCurrentChangeRight(val) {
      this.currentPageRight = val;
    },
    handleDownload() {
      this.$confirm(`确认下载离线状态数据吗？`).then(() => {
        // 下载
        // 请求参数
        this.checktime();
        const params = {
          source: [...this.category], // 业务分类
          company_id_list: [...this.store], // 景区列表
          lte: this.lte,
          gte: this.gte,
          // company_id_list: ['cad7d66f2e6bec50'] // 景区列表
        };
        getDeviceOfflineDownload(params)
          .then((data) => {
            this.download(data);
          })
          .catch((error) => {
            this.$message.error(error);
          });
      });
    },
    download(resp) {
      const fileName = "设备离线状态";
      const blob = new Blob([resp.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const href = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = href;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(a.href);
      }
    },
  },
  components: {
    SearchSelect,
    DeviceStatusChart,
  },
  computed: {
    storeOptions() {
      let arr = [];
      if (!Array.isArray(this.allStore)) return arr;
      this.allStore.map((val) => {
        arr.push({ label: val.name, value: val.id });
      });
      return arr;
    },
    // 计算属性，根据当前页和每页条数获取当前显示的数据
    displayedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      if (this.offlineList && this.offlineList.length > 0) {
        return this.offlineList.slice(start, end);
      } else {
        return [];
      }
    },
    displayedDataRight() {
      const start = (this.currentPageRight - 1) * this.pageSize;
      const end = start + this.pageSize;
      if (this.salesStatusList && this.salesStatusList.length > 0) {
        return this.salesStatusList.slice(start, end);
      } else {
        return [];
      }
    },
  },
};
</script>

<style scoped>
/* 改变滚动条的宽度和颜色 */
::-webkit-scrollbar {
  background-color: transparent;
  width: 10px;
  border: 1px solid;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb {
  background-color: #58d9f9;
  border-radius: 5px;
}

/* 改变滚动条被悬停时的颜色 */
::-webkit-scrollbar-thumb:hover {
  background-color: #7cffb2;
}

/* 改变滚动条的轨道宽度和颜色 */
::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 5px;
}

.pageTop {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
}

.pageTop h1 {
  margin-right: 30px;
  font-size: 22px;
  font-weight: bold;
}

.pageTop h2 {
  margin-right: 10px;
  margin-left: 10px;
}

.pageTop .mineSelect {
  margin: 0 30px;
}

.statusPage,
.deviceBox {
  font-size: 16px;
  color: #ffffff;
  padding: 10px;
  /* border: 1px solid #5c01b8; */
  border-radius: 30px;
  width: 95%;
  margin: 10px auto;
}

.statusPage {
  box-shadow: 0 0 10px;
  /*border-color: #58D9F9;*/
}

.statusPage .el-button {
  margin-left: 10px;
}

.title {
  display: flex;
  justify-content: center;
  align-items: center;
}

.title h2 {
  margin-right: 20px;
  margin-left: 20px;
  font-size: 20px;
}

@media (max-width: 1400px) {
  .leftBox,
  .rightBox {
    width: 80%;
  }
}

@media (min-width: 1400px) {
  .deviceBox {
    display: flex;
    /* justify-content: space-around; */
  }

  .leftBox,
  .rightBox {
    width: 50%;
  }
}

.leftBox ul,
.rightBox ul {
  /*height: 300px;*/
  /*overflow-y: scroll;*/
  margin-top: 10px;
  padding: 0 5%;
}

.leftBox li,
.rightBox li {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
}

.rightBox h2 {
  height: 32px;
  line-height: 32px;
  text-align: center;
}

.el-button:hover {
  color: #ffffff;
  background-color: #5c01b8;
  border-color: #5c01b8;
}

.noData {
  text-align: center;
  margin-top: 30px;
}
/* // 悬浮窗样式 */
.tooltip-title {
  font-weight: 700;
}
</style>

<style>
.totalNum {
  width: 100%;
  margin: 20px auto;
}

.totalNum__left {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 690px;
  padding: 15px 20px;
  border-radius: 10px;
  /* background-color: rgba(255, 255, 255, 0.9); */
  border: 1px solid #e0e0e0;
  margin: 20px auto;
  box-shadow: 0 4px 15px rgba(80, 180, 255, 0.15);
}

.totalNum__left div {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px 15px;
  border-radius: 8px;
  /* background: linear-gradient(135deg, #f0f8ff, #e6f2ff); */
  transition: all 0.2s ease;
}

.totalNum__left div:first-child {
  margin-right: 15px;
}

.totalNum__left p {
  display: flex;
  margin: 0;
  line-height: 24px;
  font-size: 14px;
  /* color: #666; */
}

.totalNum__left .count {
  margin-top: 8px;
  font-size: 26px;
  font-weight: 600;
  background: linear-gradient(to right, #58d9f9, #3aa0f3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.totalNum__left i {
  display: inline-block;
  text-align: center;
  line-height: 24px;
  width: 24px;
  height: 24px;
  font-size: 16px;
  font-weight: 700;
  margin-left: 10px;
  color: #fff;
  border-radius: 50%;
  background: #ff7c7c;
}
.totalNum__right h3 {
  margin: 20px 0 20px;
  margin-left: 12px;
}
.totalNum__right i {
  display: inline-block;
  text-align: center;
  line-height: 24px;
  width: 24px;
  height: 24px;
  font-size: 16px;
  font-weight: 700;
  margin-left: 10px;
  color: #fff;
  border-radius: 50%;
  background: linear-gradient(to right, #58d9f9, #3aa0f3);
}

.totalNum__left div:first-child i {
  background: linear-gradient(to right, #58d9f9, #3aa0f3);
  box-shadow: 0 2px 6px rgba(88, 217, 249, 0.3);
}

.totalNum__left div:last-child i {
  margin-left: 10px;
  background-color: #ff7c7c;
  box-shadow: 0 2px 6px rgba(255, 124, 124, 0.3);
}

/* 当数字变化时的平滑过渡 */
@keyframes pulseCount {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.count.updated {
  animation: pulseCount 0.5s ease;
}

/* 添加一个微妙的线条指示器 */
.totalNum__left div::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 15px;
  width: 40px;
  height: 2px;
  transition: width 0.3s ease;
}

.totalNum__left div:hover::after {
  width: calc(100% - 30px);
}
::v-deep .custom-tooltip {
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 10px;
  font-size: 14px;
  line-height: 1.4;
  max-width: 300px;
  word-break: break-word;
  text-align: center;
}

::v-deep .custom-tooltip .popper__arrow {
  border-top-color: rgba(0, 0, 0, 0.7);
}
</style>